import type { RefObject } from 'react';
import { createContext, useContext } from 'react';

export type THeaderState = {
	headerRef: RefObject<HTMLDivElement | null>;
	headerOffset: number;
	isSideMenuOpen: boolean;
	isLanguageOpen: boolean;
	sideMenuClose: () => void;
	toggleSideMenu: () => void;
	setHeaderOffset: (offset: number) => void;
	languageOpen: () => void;
	languageClose: () => void;
};

export const HeaderContext = createContext<THeaderState>({
	headerRef: { current: null },
	headerOffset: 0,
	isSideMenuOpen: false,
	isLanguageOpen: false,
	sideMenuClose: () => undefined,
	toggleSideMenu: () => undefined,
	setHeaderOffset: () => undefined,
	languageOpen: () => () => undefined,
	languageClose: () => undefined,
});

export const useHeaderContext = () => {
	const context = useContext(HeaderContext);
	if (!context) {
		throw Error('HeaderContext no context Provider');
	}
	return context;
};
